import React from 'react';
import { Instagram, Mail } from 'lucide-react';
import { PavilionLogo } from './PavilionLogo';
export function Footer() {
  return <footer className="bg-foodCream pb-8" data-id="element-43" data-mp="3ggty8ibanj58">
      <div className="bg-foodMaroon text-foodCream text-center py-10 px-4 mb-16" data-id="element-44" data-mp="32nummremu92y">
        <p className="font-display font-wide font-extrabold uppercase text-sm sm:text-lg" data-id="element-45" data-mp="32m1bozwzl2p5">
          <span className="text-foodGold" data-id="element-46" data-mp="36nd57gize82m">Mon</span> 9 AM – 2 PM •{' '}
          <span className="text-foodGold" data-id="element-47" data-mp="3ugbqj7nstejc">Wed</span> 2 PM – 7 PM •{' '}
          <span className="text-foodGold" data-id="element-48" data-mp="39904ifsbca6">Sat & Sun</span> 12 PM – 6 PM
        </p>
        <p className="font-wide font-display font-extrabold uppercase text-3xl sm:text-4xl text-foodGold mt-3" data-id="element-49" data-mp="3lem1u9lawtp9">
          Come Hungry. Come Often.
        </p>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-50" data-mp="3qfji2gmr3do4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-51" data-mp="29y5fdwbbxcsw">
          <div className="md:col-span-2" data-id="element-52" data-mp="2ey05vyr700df">
            <a href="#" aria-label="The Food Pavilion, home" className="inline-block mb-4" data-id="element-53" data-mp="2ezuvhqdesgnu">
              <PavilionLogo data-id="element-54" data-mp="3labqttpu02pb" />
            </a>
            <p className="text-foodMaroon/80 font-medium max-w-sm mb-6" data-id="element-55" data-mp="3gagzxq623d49">
              A community food hub dedicated to creating pathways to prosperity
              for local culinary talent while bringing neighbors together.
            </p>
            <div className="flex gap-4" data-id="element-56" data-mp="3q7lqs3aujwre">
              <a href="https://www.instagram.com/thefoodpavilionsf/" target="_blank" rel="noopener noreferrer" aria-label="Follow The Food Pavilion on Instagram" className="w-12 h-12 bg-foodMaroon text-foodCream flex items-center justify-center hover:bg-foodOrange transition-colors border-2 border-foodMaroon" data-id="element-57" data-mp="3qazqt4w1ftvo">
                <Instagram size={24} data-id="element-58" data-mp="qthxei3d6y2b" />
              </a>
              <a href="#" aria-label="Email The Food Pavilion" className="w-12 h-12 bg-foodMaroon text-foodCream flex items-center justify-center hover:bg-foodOrange transition-colors border-2 border-foodMaroon" data-id="element-59" data-mp="qub97xh6kdrb">
                <Mail size={24} data-id="element-60" data-mp="ytejsg6pcas7" />
              </a>
            </div>
          </div>

          <div data-id="element-61" data-mp="13sr3is2a11qk">
            <h4 className="font-extrabold uppercase text-xl mb-4" data-id="element-62" data-mp="13t0y6sy9nx2l">Explore</h4>
            <ul className="space-y-2 font-bold" data-id="element-63" data-mp="18jr2e2uyhtvp">
              <li data-id="element-64" data-mp="18lkbdot1kq6v">
                <a href="#popups" className="hover:text-foodOrange transition-colors" data-id="element-65" data-mp="18m3nupzxamdi">
                  Weekend Pop-Ups
                </a>
              </li>
              <li data-id="element-66" data-mp="1mjsbu6pae9ms">
                <a href="#menu" className="hover:text-foodOrange transition-colors" data-id="element-67" data-mp="1mj8uos7gnp9t">
                  Pavilion Menu
                </a>
              </li>
              <li data-id="element-68" data-mp="3obx11afeistt">
                <a href="#hours" className="hover:text-foodOrange transition-colors" data-id="element-69" data-mp="3ocgi6ox89d6s">
                  Hours
                </a>
              </li>
              <li data-id="element-70" data-mp="2afx12vlms13v">
                <a href="#workshops" className="hover:text-foodOrange transition-colors" data-id="element-71" data-mp="2agevrnsna79o">
                  Workshops
                </a>
              </li>
              <li data-id="element-72" data-mp="21kpgzxlpcb59">
                <a href="#vendors" className="hover:text-foodOrange transition-colors" data-id="element-73" data-mp="1wnpaxmour8e5">
                  Become a Vendor
                </a>
              </li>
              <li data-id="element-74" data-mp="2pbuu4509cpbv">
                <a href="#partners" className="hover:text-foodOrange transition-colors" data-id="element-75" data-mp="2pdfnvser048o">
                  Partner With Us
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-76" data-mp="2fgb39x0jwgtz">
            <h4 className="font-extrabold uppercase text-xl mb-4" data-id="element-77" data-mp="18y4ogtthpt04">Visit Us</h4>
            <address className="not-italic font-medium text-foodMaroon/80 space-y-2" data-id="element-78" data-mp="18w1obgymijho">
              <p data-id="element-79" data-mp="13xqf98g5kd0i">India Basin Waterfront Park</p>
              <p data-id="element-80" data-mp="2rv7nhsq2vpyo">900 Innes Ave</p>
              <p data-id="element-81" data-mp="2ruy08cwf3wwo">San Francisco, CA 94124</p>
              <p className="pt-2 font-bold text-foodMaroon" data-id="element-82" data-mp="2wmg0eyqm9tgl">Hours:</p>
              <p data-id="element-83" data-mp="2wnr46yk2b17p">Monday • 9 AM – 2 PM</p>
              <p data-id="element-84" data-mp="2ivb7efhr7zf8">Wednesday • 2 PM – 7 PM</p>
              <p data-id="element-85" data-mp="2iwm9mavjwz48">Saturday & Sunday • 12 PM – 6 PM</p>
            </address>
          </div>
        </div>

        <div className="border-t-4 border-foodMaroon pt-10 pb-10 flex flex-col items-center gap-6" data-id="element-86" data-mp="2nunqcp5i8mcj">
          <h4 className="font-extrabold uppercase text-sm tracking-widest text-foodMaroon/60" data-id="element-87" data-mp="3bk8fxqw5yhus">
            In Partnership With
          </h4>
          <div className="flex flex-wrap items-center justify-center gap-8 sm:gap-12" data-id="element-88" data-mp="31lswma3docvu">
            <img src="https://cdn.magicpatterns.com/uploads/2ZSi3AccgZnEUBmfgiuxMw/Untitled_design_(4).png" alt="San Francisco Recreation & Parks" className="h-24 w-auto object-contain" data-id="element-89" data-mp="36kndh6hsbrdb" />
            <img src="https://cdn.magicpatterns.com/uploads/nYkbhZjohnn3Xbm3r4WWAs/Untitled_design_(5).png" alt="India Basin Waterfront Park, San Francisco" className="h-24 w-auto object-contain" data-id="element-90" data-mp="1v6i603id4zd8" />
          </div>
        </div>

        <div className="border-t-4 border-foodMaroon pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-91" data-mp="1wn5pyp76ynpk">
          <p className="font-bold text-sm" data-id="element-92" data-mp="1rom1ah17qxti">
            © {new Date().getFullYear()} The Food Pavilion. All rights
            reserved.
          </p>
          <div className="flex gap-4 text-sm font-bold" data-id="element-93" data-mp="zwd9vrk9cvns">
            <a href="#" className="hover:text-foodOrange" data-id="element-94" data-mp="zxofzy16efi2">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-foodOrange" data-id="element-95" data-mp="1dpcmnlsnobrn">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}